
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help-and-support/faqs/[slug]",
      function () {
        return require("private-next-pages/help-and-support/faqs/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help-and-support/faqs/[slug]"])
      });
    }
  